import * as React from "react";
import { ModalComponent } from "shared/components/modal/modal";
import { IconPhone } from "themes";
import LogoDK from "../../../themes/img/logo.png";
interface INonCashModal {
  open: boolean;
  nonCashAdjRate: number;
  onClose: () => void;
}
export function NonCashModal(props: INonCashModal) {
  const { open, onClose, nonCashAdjRate } = props;
  return (
    <ModalComponent
      width={`100%`}
      height={`100%`}
      isModal={false}
      className="w-full bg__red customer__notice rounded-2xl"
      isCustomizeFooter={true}
      onCloseModal={onClose}
      isOpenModal={open}
      title={<div className="title flex justify-between text-white">
        <div className="logo-container">
          <img src={LogoDK} alt="" />
        </div>
        <div className="phone-container flex content-center items-center">
          <div className="icon mr-2">
            <IconPhone width={20} />
          </div>
          <span>888-264-2764</span>
        </div>
      </div>}
    >
      <div className="p-4 content-inner">
        <div className="title__container">
          <h1 className="uppercase p-4 text--red">Customer Notice</h1>
        </div>
        <div style={{ fontSize: 17 }}>
          <div className="content__top">
            <p>
              Prices listed in-store and on advertisements reflect our{" "}
              <b>cash price</b>.
            </p>
            <p className="text-center">
              <b>
                OUR REGULAR PRICE INCLUDES <br /> A {nonCashAdjRate}% NON-CASH ADJUSTMENT
              </b>
            </p>
            <p>We offer savings at the point of sale when you pay with cash!</p>
          </div>
        </div>
        <p className="mt-20" style={{ fontSize: 10, marginBottom: 30 }}>
          The purpose of the non-cash adjustment is to incentivize customers to
          pay with cash. This is an "in-kind incentive" in compliance with
          section (2)(A) of the Durbin Amendment, a provision of United States
          Federal Law, 15 U.S.C &amp; 169o-2. We further provide a Cash Discount
          from the regular price in accordance with section (4)(c)(4) of the
          same document. This sign is meant to inform customers of our regular
          price in compliance with this law.
        </p>
        <div className="flex justify-center gap-3">
          <img
            className="h-24"
            src={process.env.PUBLIC_URL + "/images/visa.jpg"}
            alt=""
          />
          <img
            className="h-24"
            src={process.env.PUBLIC_URL + "/images/master.jpg"}
            alt=""
          />
          <img
            className="h-24"
            src={process.env.PUBLIC_URL + "/images/american-express.jpg"}
            alt=""
          />
          <img
            className="h-24"
            src={process.env.PUBLIC_URL + "/images/discover.jpg"}
            alt=""
          />
        </div>
      </div>
    </ModalComponent>
  );
}
